import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import useQueryReports from "@/hooks/queries/useQueryReports";
import { Styled } from "./styles";
import { i18n } from "@/utils/i18n";
import { useTableHelper } from "./hooks";
import Header from "./header";
import useLocale from "@/context/locale";
import localeTextMap from "@/utils/i18n/data-grid";

interface Props {
    reviewStatus: string;
    title: string;
}

const Table: React.FC<Props> = ({ reviewStatus, title }) => {
    const locale = useLocale(state => state.locale);

    const [search, setSearch] = useState("");
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 25,
        page: 0,
    });

    const { data, isLoading, isFetching, refetch } = useQueryReports({ reviewStatus });
    const reports = data?.items ?? [];
    const { columns, rows } = useTableHelper(reports, search);
    const total = rows.length;

    return (
        <Styled.Container>
            <Header
                refetch={refetch}
                setSearch={setSearch}
                search={search}
                isLoading={isLoading}
                isFetching={isFetching}
                title={title}
                total={total}
                rows={rows}
            />
            <Styled.GridWrapper>
                <DataGrid
                    slotProps={{
                        pagination: {
                            labelRowsPerPage: i18n.t("rowsPerPage"),
                            labelDisplayedRows: ({ from, to, count }) =>
                                `${from}–${to} ${i18n.t("of")} ${count}`,
                            count: total,
                        },
                    }}
                    columns={columns}
                    rows={rows}
                    loading={isLoading || isFetching}
                    localeText={localeTextMap[locale]}
                    rowHeight={50}
                    columnHeaderHeight={46}
                    disableColumnMenu={true}
                    disableRowSelectionOnClick={true}
                    pageSizeOptions={[5, 10, 25]}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    initialState={{
                        sorting: {
                            sortModel: [{ field: "receivedAt", sort: "asc" }],
                        },
                    }}
                />
            </Styled.GridWrapper>
        </Styled.Container>
    );
};

export default Table;
